export const dateTimePaperPropsStyles = {
  sx: {
    '.MuiPickersCalendarHeader-root': {
      display: 'flex',
      alignItems: 'center',
      justifyItems: 'center'
    },
    '.MuiPickersCalendarHeader-root:first-of-type': {
      order: 0,
      paddingRight: '20px',
      paddingLeft: '20px',
      borderBottom: '1px solid #E6E9EE',
      marginX: '5px',
      pb: '15px'
    },
    '.MuiPickersArrowSwitcher-root': {
      display: 'inline-flex'
    },
    '.MuiPickersCalendarHeader-label': {
      textAlign: 'center'
    },
    '.MuiPickersArrowSwitcher-spacer': {
      width: '220px'
    },
    '.css-31ca4x-MuiPickersFadeTransitionGroup-root': {
      position: 'absolute',
      marginLeft: 'auto',
      marginRight: 'auto',
      left: 0,
      right: 0,
      textAlign: 'center'
    },
    '.MuiPickersArrowSwitcher-button': {
      paddingRight: '7px'
    },
    '& .MuiDayCalendar-weekDayLabel': {
      fontWeight: 500,
      color: 'var(--dark)',
      fontSize: '0.85rem'
    },
    '& .MuiPickersDay-dayWithMargin': {
      fontWeight: 500,
      color: 'var(--dark)',
      fontSize: '0.85rem'
    },
    '& .MuiPickersDay-dayOutsideMonth': {
      fontWeight: 500,
      color: '#BDBDBD !important'
    },
    '& .Mui-selected': {
      color: '#00A7CF !important',
      background: '#E6F8FC !important'
    }
  }
}

export * from './EFDatePicker.component'
